import React, { useEffect, useState } from 'react';
import { useLocation, useHistory } from 'react-router-dom';
import styles from './MyAppHandler.module.css';
import { getCustomerConfig } from '../../../helpers';

const customerConfig = getCustomerConfig();
const { deeplink: { androidIntentPackage, appleSlug, appleStoreId } } = customerConfig;

const playStoreUrl = `https://play.google.com/store/apps/details?id=${androidIntentPackage}`;
const appStoreUrl = `https://apps.apple.com/it/app/${appleSlug}/id${appleStoreId}`;

// App store badge images
const playStoreBadgeUrl =
  'https://play.google.com/intl/en_us/badges/images/generic/it_badge_web_generic.png';
const appStoreBadgeUrl =
  'https://developer.apple.com/assets/elements/badges/download-on-the-app-store.svg';

// Air logo
const airLogo = '/logo@10x-gli.png';

const MyAppHandler = () => {
  const location = useLocation();
  const history = useHistory();
  const [redirecting, setRedirecting] = useState(true);

  useEffect(() => {
    const handleAppLink = () => {
      // Get the path after /myapp/
      const fullPath = location.pathname;
      const pathAfterMyApp = fullPath.replace(/^\/myapp\/?/, '');

      // Detect device type
      const isAndroid = /android/i.test(navigator.userAgent);
      const isIOS = /iphone|ipad|ipod/i.test(navigator.userAgent);
      const isMobile = isAndroid || isIOS;

      console.debug('Device detection:', { isAndroid, isIOS, isMobile });
      console.debug('Path after /myapp/:', pathAfterMyApp);

      // Handle redirection based on device type
      if (isMobile) {
        // For mobile devices, redirect to the app store

        console.debug('Redirecting to app store...');

        if (isAndroid) {
          window.location.href = playStoreUrl;
        } else {
          window.location.href = appStoreUrl;
        }
      } else {
        //if new path contains services and other sub path redirect to services
        if (pathAfterMyApp.startsWith('services')) {
          console.debug('Redirecting to services page...');
          history.push('/services');
          return;
        }
        // For desktop, remove /myapp from the path and redirect
        const webPath = pathAfterMyApp ? `/${pathAfterMyApp}` : '/';
        console.debug('Redirecting to web path:', webPath);
        history.push(webPath);
      }
    };

    // Short delay to ensure the component is mounted before redirection
    const timer = setTimeout(() => {
      handleAppLink();
      setRedirecting(false);
    }, 100);

    return () => clearTimeout(timer);
  }, [location.pathname, history]);

  return (
    <div className={redirecting ? styles.loadingContainer : styles.container}>
      {redirecting ? (
        <>
          <div className={styles.spinner}></div>
          <p className={styles.paragraph}>Reindirizzamento in corso...</p>
        </>
      ) : (
        <>
          <div className={styles.logo}>
            <img
              src={airLogo}
              alt='Air Logo'
              className={styles.logoImage}
              loading='lazy'
            />
          </div>
          <h2 className={styles.heading}>Impossibile aprire l'app</h2>
          <p className={styles.paragraph}>
            Se non sei stato reindirizzato automaticamente, scarica la nostra
            app:
          </p>
          <div className={styles.badgeContainer}>
            <a href={playStoreUrl} className={styles.storeLink}>
              <img
                src={playStoreBadgeUrl}
                alt='Disponibile su Google Play'
                className={styles.playStoreBadge}
              />
            </a>
            <a href={appStoreUrl} className={styles.storeLink}>
              <img
                src={appStoreBadgeUrl}
                alt='Scarica su App Store'
                className={styles.appStoreBadge}
              />
            </a>
          </div>
        </>
      )}
    </div>
  );
};

export default MyAppHandler;
